import { db } from '../firebase.js';
import {
    collection,
    doc,
    setDoc,
    getDoc,
    updateDoc,
    onSnapshot,
    addDoc,
    serverTimestamp
} from 'firebase/firestore';

// Create a room
export const createRoom = async (roomId) => {
    const roomRef = doc(db, 'rooms', roomId);
    await setDoc(roomRef, { created: serverTimestamp() });
    return roomRef;
};

// Join a room (check if exists)
export const getRoom = async (roomId) => {
    const roomRef = doc(db, 'rooms', roomId);
    const roomSnap = await getDoc(roomRef);
    return roomSnap.exists() ? roomSnap.data() : null;
};

// Add ICE candidate
export const addCandidate = async (roomId, candidate, type) => {
    // type: 'callerCandidates' or 'calleeCandidates'
    const roomRef = doc(db, 'rooms', roomId);
    const candidatesCollection = collection(roomRef, type);
    await addDoc(candidatesCollection, candidate.toJSON());
};

// Listen for ICE candidates
export const registerPeerConnectionListeners = (pc, roomId, type) => {
    // type: 'callerCandidates' or 'calleeCandidates'
    const roomRef = doc(db, 'rooms', roomId);
    const candidatesCollection = collection(roomRef, type);

    const unsubscribe = onSnapshot(candidatesCollection, (snapshot) => {
        snapshot.docChanges().forEach(async (change) => {
            if (change.type === 'added') {
                const data = change.doc.data();
                const candidate = new RTCIceCandidate(data);
                try {
                    await pc.addIceCandidate(candidate);
                } catch (error) {
                    console.error("Error adding ice candidate:", error);
                }
            }
        });
    });
    return unsubscribe;
};

// Save Offer
export const saveOffer = async (roomId, offer) => {
    const roomRef = doc(db, 'rooms', roomId);
    await updateDoc(roomRef, { offer });
};

// Save Answer
export const saveAnswer = async (roomId, answer) => {
    const roomRef = doc(db, 'rooms', roomId);
    await updateDoc(roomRef, { answer });
};

// Listen for Offer/Answer updates
export const listenToRoom = (roomId, onUpdate) => {
    const roomRef = doc(db, 'rooms', roomId);
    return onSnapshot(roomRef, (snapshot) => {
        if (snapshot.exists()) {
            onUpdate(snapshot.data());
        }
    });
};
